/** @jsxImportSource @emotion/react */
import React, { useCallback, useContext, useState } from "react";
import Carousel, { Modal, ModalGateway } from "react-images";
import Gallery from "react-photo-gallery";
import { LocaleContext } from "../../context/LocaleContext";
import { stySectionTitle } from "../styles";
import { txtGalleryTitle } from "./locales";
import { photos } from "./photos";
import { styGallerySection } from "./styles";

const OurGallery = () => {
  const { lang } = useContext(LocaleContext);
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  return (
    <section css={styGallerySection}>
      <div css={stySectionTitle}>
        <h1>{txtGalleryTitle[lang]}</h1>
      </div>
      <Gallery photos={photos} onClick={openLightbox} margin={4} />
      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={photos.map((x) => ({
                ...x,
                srcset: x.srcSet,
                caption: x.title,
              }))}
            />
          </Modal>
        ) : (
          <></>
        )}
      </ModalGateway>
    </section>
  );
};

export default OurGallery;
